import { useContext, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import BtnLink from '@/components/BtnLink'
import { Context as GeneralContext } from '@/context'
import ParallaxImg from '@/components/ParallaxImg'
import style from './style'

const useStyles = createUseStyles(style)

const PageElements = ({
  className,
  elements,
  stub,
}) => {
  const { getImageUrl } = useContext(GeneralContext)
  const classes = useStyles()
  const $root = useRef()

  /*------------------------------
  Render ColumnText
  ------------------------------*/
  const renderColumnText = (el, i) => {
    return (
      <div
        key={i}
        className={classes.wrapper}
      >
        <div
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: el.element_text }}
        />
      </div>
    )
  }

  /*------------------------------
  Render SingleImage
  ------------------------------*/
  const renderSingleImage = (el, i) => {
    return (
      <div
        key={i}
        className={classes.wrapper}
      >
        <div className={classes.imageWrapper}>
          <ParallaxImg
            img={getImageUrl(el.element_img, 'full', stub)}
            alt={el.title}
          />
        </div>
      </div>
    )
  }

  /*------------------------------
  Render Link
  ------------------------------*/
  const renderLink = (el, i) => {
    return (
      <div
        key={i}
        className={classes.wrapper}
      >
        <BtnLink
          link={el.element_link}
          label={el.element_label}
          theme="light"
          fill
        />
      </div>
    )
  }

  /*------------------------------
  Render Page Elements
  ------------------------------*/
  const renderPageElements = (pageElements) => {
    return pageElements && pageElements.map((element, i) => {
      if (element.layout_choice === 'text') return renderColumnText(element, i)
      if (element.layout_choice === 'image') return renderSingleImage(element, i)
      // if (element.layout_choice === 'gallery') return renderGallery(element, i)
      if (element.layout_choice === 'link') return renderLink(element, i)
      return null
    })
  }

  /*------------------------------
  Render
  ------------------------------*/
  return elements.length !== 0 && (
    <div
      className={`${classes.root} ${className}`}
      ref={$root}
    >
      {renderPageElements(elements)}
    </div>
  )
}

PageElements.defaultProps = {
  className: '',
  stub: '',
  elements: [],
}

export default PageElements
